export default __webpack_public_path__ + "static/media/r11.7e44ba96.jpg";